var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowRoundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white",
    fillOpacity: 0.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.0005H11.83L14.71 12.1205C15.1 11.7305 15.1 11.1005 14.71 10.7105C14.32 10.3205 13.69 10.3205 13.3 10.7105L8.70998 15.3005C8.31998 15.6905 8.31998 16.3205 8.70998 16.7105L13.3 21.3005C13.69 21.6905 14.32 21.6905 14.71 21.3005C15.1 20.9105 15.1 20.2805 14.71 19.8905L11.83 17.0005H25C25.55 17.0005 26 16.5505 26 16.0005C26 15.4505 25.55 15.0005 25 15.0005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowRoundedIcon);
export default __webpack_public_path__ + "static/media/back-arrow-rounded-icon.4566920a61a76abb1042494d68898149.svg";
export { ForwardRef as ReactComponent };